import { useFieldValue } from "components/form/input/NestedField";
import TextInput from "components/form/input/TextInput";
import ApontamentoColetas from "entity/Indicador/components/apontamento/fields/ApontamentoColetas";
import ApontamentoCommonFields from "entity/Indicador/components/apontamento/fields/ApontamentoCommonFields";
import ApontamentoImages from "entity/Indicador/components/apontamento/fields/ApontamentoImages";
import ApontamentoClienteParams, {
    ApontamentoParamItem,
} from "entity/Indicador/components/apontamento/fields/ApontamentoClienteParams";
import ApontamentoAmostraParams, {
    useTipoApontamento,
} from "entity/Indicador/components/apontamento/fields/ApontamentoAmostraParams";
import ApontamentoResultado from "entity/Indicador/components/apontamento/fields/ApontamentoResultado";
import ApontamentoObservacao from "entity/Indicador/components/apontamento/fields/ApontamentoObservacao";
import { useEffect } from "react";
import EES from "..";
import FormRow from "components/form/FormRow";
import SelectInput from "components/form/input/SelectInput";
import { useForm } from "react-final-form";
import EntitySearchInput from "components/form/EntitySearch/EntitySearchInput";
import Operador from "entity/Operador";

export default function EESEditFields({ visita, TipoClass }) {
    const [tipo] = useTipoApontamento();
    const params = visita.cliente.getParams(EES, tipo, TipoClass);

    const [apontamento] = useFieldValue();
    const form = useForm();

    useEffect(() => {
        if (apontamento) {
            apontamento.conformidade = EES.calcConformidade(apontamento, params);
            form.change("conformidade", EES.calcConformidade(apontamento, params));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [apontamento, params]);

    return (
        <>
            <ApontamentoCommonFields visita={visita} TipoClass={TipoClass} showVariedade />

            <ApontamentoAmostraParams>
                {TipoClass.field === "plantio" && (
                    <FormRow>
                        <EntitySearchInput
                            name="operador"
                            label="Operador"
                            EntityClass={Operador}
                            extraQuery={(query) => query.where("cliente.uid", "==", visita.data.cliente.uid)}
                        />
                    </FormRow>
                )}
                <FormRow>
                    <SelectInput name="turno" label="Turno" options={["A", "B", "C"]} required />
                </FormRow>
            </ApontamentoAmostraParams>

            <ApontamentoClienteParams params={params}>
                {params ? (
                    <>
                        <ApontamentoParamItem label="Intervalo:">
                            ({params.intervaloMin}, {params.intervaloMax})
                        </ApontamentoParamItem>
                        <ApontamentoParamItem label="Meta (%):">{params.meta}</ApontamentoParamItem>
                    </>
                ) : null}
            </ApontamentoClienteParams>

            <ApontamentoColetas visita={visita}>
                <TextInput type="number" name="espacamento" label="Espaçamento" />
                <TextInput name="conforme" label="Conforme" disabled />
            </ApontamentoColetas>

            <ApontamentoResultado />
            <ApontamentoObservacao />
            <ApontamentoImages visita={visita} />
        </>
    );
}
